<mat-expansion-panel *appHasFeature="features.TAB_USER_TIME_OFF" togglePosition="before" expanded>
    <mat-expansion-panel-header>

      <h4 appLocalizationPopupDirective localizationCode="Homepage-TimeOff">
        {{ 'Homepage-TimeOff' | translate: {Default: "Time Off"} }}
      </h4>
    </mat-expansion-panel-header>
  
    <ng-template matExpansionPanelContent>

      <div class="time-off-container">
        <app-time-off-policy-widget (timeOffRequestCreated)="timeOffRequestCreated($event)"></app-time-off-policy-widget>
        
        <app-my-time-off-requests [refreshMyTimeOffRequest]="refreshMyTimeOffRequest"></app-my-time-off-requests>
      </div>

    </ng-template>
</mat-expansion-panel>

<mat-expansion-panel *appHasFeature="features.TAB_TOIL" togglePosition="before">
    <mat-expansion-panel-header>
      <h4 appLocalizationPopupDirective localizationCode="Homepage-TOIL">
        {{ 'Homepage-TOIL' | translate: {Default: "TOIL"} }}
      </h4>
    </mat-expansion-panel-header>
  
    <ng-template matExpansionPanelContent>
      <div class="time-off-container">
        <app-toil-policy-widget (toilRequestCreated)="toilRequestCreated($event)"></app-toil-policy-widget>
        
        <app-my-toil-requests [refreshMyToilRequest]="refreshMyToilRequest"></app-my-toil-requests>
      </div>
    </ng-template>
</mat-expansion-panel>

<mat-expansion-panel togglePosition="before" *appHasFeature="features.TAB_SCHEDULE">
    <mat-expansion-panel-header>
      <h4 appLocalizationPopupDirective localizationCode="Homepage-Schedule">
        {{ 'Homepage-Schedule' | translate: {Default: "Schedule"} }}
      </h4>
    </mat-expansion-panel-header>
  
    <ng-template matExpansionPanelContent>
      <app-schedule-widget></app-schedule-widget>
    </ng-template>
</mat-expansion-panel>

<mat-expansion-panel togglePosition="before" *appHasFeature="features.TAB_USER_BUY_SELL">
    <mat-expansion-panel-header>
      <h4 appLocalizationPopupDirective localizationCode="Homepage-BuySell">
        {{ 'Homepage-BuySell' | translate: {Default: "Buy/Sell"} }}
      </h4>
    </mat-expansion-panel-header>
  
    <ng-template matExpansionPanelContent>
      <app-employee-buy-sell [showTitle]="false" [employeeId]="user$.userId"></app-employee-buy-sell>
    </ng-template>
</mat-expansion-panel>

<!-- <mat-expansion-panel togglePosition="before">
  <mat-expansion-panel-header>
    <h4 appLocalizationPopupDirective localizationCode="TeamMembersSchedule">{{ 'TeamMembersSchedule' | translate: {Default: "Team Members Schedule"} }}</h4>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <app-team-members-schedule-widget></app-team-members-schedule-widget>
  </ng-template>
</mat-expansion-panel> -->


